import { useEffect, useRef, useState } from "react";

// Calm ambient pad synthesised with the Web Audio API — no asset needed.
export function useAmbientAudio() {
  const [playing, setPlaying] = useState(false);
  const ctxRef = useRef(null);
  const nodesRef = useRef([]);

  const stop = () => {
    nodesRef.current.forEach((n) => {
      try { n.stop && n.stop(); } catch (e) { /* already stopped */ }
      try { n.disconnect && n.disconnect(); } catch (e) { /* noop */ }
    });
    nodesRef.current = [];
    if (ctxRef.current) {
      try { ctxRef.current.close(); } catch (e) { /* noop */ }
      ctxRef.current = null;
    }
    setPlaying(false);
  };

  const start = () => {
    const AC = window.AudioContext || window.webkitAudioContext;
    if (!AC) return;
    const ctx = new AC();
    ctxRef.current = ctx;
    const master = ctx.createGain();
    master.gain.value = 0.0001;
    master.gain.exponentialRampToValueAtTime(0.09, ctx.currentTime + 4);
    const filter = ctx.createBiquadFilter();
    filter.type = "lowpass";
    filter.frequency.value = 700;
    filter.connect(master);
    master.connect(ctx.destination);

    // Layered detuned sines form a warm, slow drone.
    [110, 164.81, 220, 246.94].forEach((freq, i) => {
      const osc = ctx.createOscillator();
      osc.type = "sine";
      osc.frequency.value = freq;
      osc.detune.value = (i - 1.5) * 6;
      const g = ctx.createGain();
      g.gain.value = 0.25;
      const lfo = ctx.createOscillator();
      lfo.frequency.value = 0.05 + i * 0.02;
      const lfoGain = ctx.createGain();
      lfoGain.gain.value = 0.12;
      lfo.connect(lfoGain);
      lfoGain.connect(g.gain);
      osc.connect(g);
      g.connect(filter);
      osc.start();
      lfo.start();
      nodesRef.current.push(osc, lfo);
    });
    setPlaying(true);
  };

  const toggle = () => (playing ? stop() : start());

  useEffect(() => () => stop(), []);

  return { playing, toggle };
}
